import { TwoCol, SubSection } from "./fundCardHelpers";
import { InfoRow } from "../UI";

// טאב "פרטי פוליסה" לפוליסות פרט/בריאות של מגדל (מקבצי MBT).
// מציג את נתוני הכותרת מ-LIFE/LIFEHLTH: מבוטח, תקופה, פרמיות, ערך פדיון.
export default function MigdalPolicyTab({ fund, cs }) {
  return (
    <TwoCol>
      <SubSection title="פרטי פוליסה" color={cs.accent}>
        <InfoRow label="מספר פוליסה" value={fund.polNum} />
        <InfoRow label="שם הפוליסה" value={fund.tochnit || fund.name} />
        <InfoRow label="חברה" value={fund.companyName} />
        <InfoRow label="סוג" value={fund.policyKind === "health" ? "בריאות" : "חיים/פרט"} />
        <InfoRow label="סטטוס" value={fund.statusLabel} />
        <InfoRow label="תחילת ביטוח" value={fund.startDate} />
        <InfoRow label="תום ביטוח" value={fund.endDate} />
      </SubSection>
      <SubSection title="כספים" color={cs.accent}>
        <InfoRow label="מבוטח/ת" value={fund.insuredName} />
        <InfoRow label="פרמיה חודשית כוללת" value={fund.premium} money bold color={cs.accent} />
        {fund.premiumsPaid > 0 && (
          <InfoRow label="סה״כ פרמיות ששולמו" value={fund.premiumsPaid} money />
        )}
        {fund.redeem > 0 && (
          <InfoRow label="ערך פדיון" value={fund.redeem} money bold color={cs.accent} />
        )}
        <InfoRow label="מספר כיסויים" value={fund.kisuimMigdal?.length} />
      </SubSection>
    </TwoCol>
  );
}
